import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { PageMetricsProvider, MetricsTracker } from '@sm/metrics';

import { ExperimentProvider } from '../Experiments';
import BasePageHead from './BasePageHead';
import { StaticContext } from '../..';
import BasePageBody, {
  propTypes as basePageBodyPropTypes,
  defaultProps as basePageBodyDefaultProps,
} from './BasePageBody';
import { useGTM, useInitialRender } from './hooks';
import ThemeProvider, {
  propTypes as themeProviderPropTypes,
  defaultProps as themeProviderDefaultProps,
} from './providers/ThemeProvider';

const BasePage = ({
  children,
  pageId,
  pageMetricsAttributes,
  legacyWeb,
  theme,
  ...bodyProps
}) => {
  const isInitialRender = useInitialRender();
  const { user, environment, 'client-config': clientConfig, GDPR } = useContext(
    StaticContext
  );
  const { countryCode: country } = environment;
  const {
    gtmId,
    mixpanelToken,
    loggingAPIPath,
    dataAnalyticsAPIPath,
  } = clientConfig;

  // init global metrics
  if (isInitialRender) {
    MetricsTracker.initialize({
      user,
      dataAnalyticsAPIPath,
      loggingAPIPath,
      country,
      legacyWeb,
      pageId,
      gtmId,
      mixpanelToken,
    });
  }
  useGTM();

  return (
    <ExperimentProvider>
      <ThemeProvider theme={theme}>
        <BasePageHead />
        <PageMetricsProvider
          pageId={pageId}
          attributes={pageMetricsAttributes}
          GDPR={GDPR}
          user={user}
          country={country}
        >
          <BasePageBody {...bodyProps}>{children}</BasePageBody>
        </PageMetricsProvider>
      </ThemeProvider>
    </ExperimentProvider>
  );
};

BasePage.propTypes = {
  legacyWeb: PropTypes.string.isRequired,
  pageId: PropTypes.string.isRequired,
  pageMetricsAttributes: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
  ...themeProviderPropTypes,
  ...basePageBodyPropTypes,
};

BasePage.defaultProps = {
  pageMetricsAttributes: null,
  ...themeProviderDefaultProps,
  ...basePageBodyDefaultProps,
};

export default BasePage;
